import { EventType } from 'src/types';

type getButtonLabelProps = {
  hasPendingRequest?: boolean;
  type: EventType;
  hasShopItem: boolean;
  isNotCheckoutModal: boolean;
  t: (key: string) => string;
};

export const getButtonLabel = ({
  hasPendingRequest = false,
  type = EventType.PUBLIC,
  isNotCheckoutModal = false,
  hasShopItem = false,
  t,
}: getButtonLabelProps): string => {
  if (hasPendingRequest) {
    return t('buttons.waiting-pending-request');
  }

  if (hasShopItem && isNotCheckoutModal) {
    return t('buttons.checkout');
  }

  if (type === EventType.EXCLUSIVE) {
    return t('buttons.send-request');
  }

  return t('buttons.book');
};
